export default __webpack_public_path__ + "static/media/iaa-logo.c6871ed1.png";